import { AgentConfig } from './types';
import { MarketingAgent } from './definitions/MarketingAgent';
import { LegalAgent } from '@/agents/legal/config';
import { FinanceAgent } from './definitions/FinanceAgent';
import { DirectorAgent } from '@/agents/director/config';
import { VideoAgent } from './definitions/VideoAgent';
import { SocialAgent } from './definitions/SocialAgent';
import { PublicistAgent } from './definitions/PublicistAgent';
import { RoadAgent } from './definitions/RoadAgent';
import { HospitalityAgent } from './definitions/HospitalityAgent';
import { EventPlannerAgent } from './definitions/EventPlannerAgent';
import { PublishingAgent } from './definitions/PublishingAgent';
import { LicensingAgent } from './definitions/LicensingAgent';
import { BrandAgent } from './definitions/BrandAgent';
import { ScreenwriterAgent } from '@/agents/screenwriter/config';
import { ProducerAgent } from '@/agents/producer/config';
import { SecurityAgent } from './definitions/SecurityAgent';
import { DevOpsAgent } from './definitions/DevOpsAgent';
import { DistributionAgent } from './definitions/DistributionAgent';
import { MusicAgent } from './definitions/MusicAgent';
import { CreativeAgent } from './definitions/CreativeAgent';
import { AnalyticsAgent } from './definitions/AnalyticsAgent';

// Phase 3: Finance Workers
import { FinanceTaxAgent } from '@/agents/finance/workers/tax.config';
import { FinanceRoyaltyAgent } from '@/agents/finance/workers/royalty.config';
import { FinanceAccountingAgent } from '@/agents/finance/workers/accounting.config';
import { RightsAgent } from '@/agents/rights/config';

export const AGENT_CONFIGS: AgentConfig[] = [
    MarketingAgent,
    LegalAgent,
    FinanceAgent,
    ProducerAgent,
    DirectorAgent,
    ScreenwriterAgent,
    VideoAgent,
    SocialAgent,
    PublicistAgent,
    RoadAgent,
    HospitalityAgent,
    EventPlannerAgent,
    PublishingAgent,
    LicensingAgent,
    BrandAgent,
    DevOpsAgent,
    SecurityAgent,
    DistributionAgent,
    MusicAgent,
    CreativeAgent,
    AnalyticsAgent,
    FinanceTaxAgent,
    FinanceRoyaltyAgent,
    FinanceAccountingAgent,
    RightsAgent
];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { VALID_AGENT_IDS, VALID_AGENT_IDS_LIST } from './types';
export { VALID_AGENT_IDS, VALID_AGENT_IDS_LIST } from './types';
export type { ValidAgentId } from './types';

import { freezeAgentConfig } from './FreezeDiagnostic';
import { logger } from '@/utils/logger';

// Safety net: freeze all agent configurations to prevent shared state contamination
AGENT_CONFIGS.forEach(agent => {
    try {
        freezeAgentConfig(agent);
    } catch (e: unknown) {
        logger.warn(`[agentConfig] Failed to freeze agent "${agent.id}":`, e);
    }
});

